module.exports = __webpack_public_path__ + "img/border_left_long.d2698762.svg";